import axios from "axios";
import i18next, { t } from "i18next";
const { VITE_PRODUCTION_BASE, VITE_APP_MODE } = import.meta.env;
import * as XLSX from "xlsx";
const PROGRAM_STAGE_MAPPING = {
  Uy3UPUWJSFF: "primaryDetails",
  ATYFvq36gIh: "accessDetails",
  k7aLsCn5hpD: "infrastructureDetails",
  LSZjNuZGXY7: "staffDetails",
  jPlvUj21OkV: "serviceDetails",
  gRrr92F5qEV: "keyData",
};
const sortStringInArrayOfObject = (array, property) => {
  return array.sort((a, b) => {
    const aProp = a[property].toUpperCase(); // ignore upper and lowercase
    const bProp = b[property].toUpperCase(); // ignore upper and lowercase
    if (aProp < bProp) {
      return -1;
    }
    if (aProp > bProp) {
      return 1;
    }
    return 0;
  });
};

const pull = async (url) => {
  return axios.get(
    (VITE_APP_MODE === "production" ? VITE_PRODUCTION_BASE : "") + url
  );
};

const findHeaderIndex = (headers, name) => {
  const found = headers.findIndex((header) => header.name === name);
  return found;
};

const primaryDetailStageId = "Uy3UPUWJSFF";

const getNewestDate = (array, field) =>
  array?.length
    ? array.reduce((max, current) => {
        if (max[field] < current[field]) return current;
        return max;
      }, array[0])
    : {};

const findOptionSet = (
  program,
  optionSetId,
  programStageId = primaryDetailStageId
) =>
  program?.programStages
    ?.find(({ id }) => id === programStageId)
    ?.programStageDataElements?.find(
      ({ dataElement: { optionSet } }) => optionSet?.id === optionSetId
    )?.dataElement?.optionSet || {};

const checkValue = (
  teiData,
  deId,
  deValues,
  programStageId = primaryDetailStageId
) =>
  teiData?.filter((tei) => {
    const newestEvent = getNewestDate(
      tei?.programStages?.[programStageId]?.events,
      "eventDate"
    );

    const value = newestEvent?.dataValues?.[deId]?.value;
    deId === "uacMVI5MLnY" && console.log(newestEvent.dataValues[deId]);
    if (!value) return false;

    const found = deValues.find((item) => item === value);
    if (!found) return false;

    return true;
  }) || [];

const checkValueAttribute = (teiData, attributeId, attributeValues) =>
  teiData?.filter((tei) => {
    const value = tei.attributes?.[attributeId]?.value;
    if (!value) return false;

    const found = attributeValues.find((item) => item === value);
    if (!found) return false;

    return true;
  }) || [];

const descendingComparator = (a, b, orderBy) => {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
};

const getComparator = (order, orderBy) => {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
};

const stableSort = (array, comparator) => {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
};

const convertMasterFacilitiesListFromSqlView = (
  result,
  serviceDeliveryProgram
) => {
  const allEvents = [];
  const facilities = [];
  result.listGrid.rows.forEach((row) => {
    const facility = {};
    result.listGrid.headers.forEach((header, headerIndex) => {
      facility[header.name] = row[headerIndex];
    });
    allEvents.push(facility);
  });

  allEvents.forEach((event) => {
    const [longitude, latitude] = event.teigeometry
      ? JSON.parse(event.teigeometry).coordinates
      : [];

    const programStage = serviceDeliveryProgram.programStages.find(
      (ps) => ps.id === event.ps
    );
    const tei = event.tei;
    const foundFacility = facilities.find((f) => f.tei === tei);
    const newEvent = {
      id: event.psi,
      eventDate: event.executiondate,
    };

    programStage.programStageDataElements.forEach((psde) => {
      const de = psde.dataElement.id;
      newEvent[de] = event[de];
    });

    if (!foundFacility) {
      const newFacility = {
        tei,
        infrastructureDetails: [],
        serviceDetails: [],
        keyData: [],
        staffDetails: [],
        accessDetails: [],
        primaryDetails: [],
      };
      serviceDeliveryProgram.programTrackedEntityAttributes.forEach((ptea) => {
        newFacility[ptea.trackedEntityAttribute.id] =
          event[ptea.trackedEntityAttribute.id];
      });
      newFacility["longitude"] = longitude;
      newFacility["latitude"] = latitude;

      newFacility[PROGRAM_STAGE_MAPPING[programStage.id]].push(newEvent);
      facilities.push(newFacility);
    } else {
      foundFacility[PROGRAM_STAGE_MAPPING[programStage.id]].push(newEvent);
    }
  });

  return facilities;
};

const pickTranslation = (object, language, field) => {
  const fieldMapping = {
    formName: "FORM_NAME",
    name: "NAME",
  };
  const foundTranslation = object.translations.find(
    (t) => t.property === fieldMapping[field] && t.locale === language
  );
  return foundTranslation ? foundTranslation.value : object[field];
};
const convertDataByDataType = (dataValue, id, metadata) => {
  if (!dataValue) return null;
  const { trackedEntityAttributes, options, orgUnits, dataElements } = metadata;
  const foundAttribute = trackedEntityAttributes.find((tea) => tea.id === id);
  const foundDataElement = dataElements.find((de) => de.id === id);
  const foundItem = foundAttribute || foundDataElement;
  if (!foundItem) return dataValue;
  if (foundItem.optionSet) {
    const foundOption = options.find(
      (option) =>
        option.code === dataValue &&
        option.optionSet.id === foundItem.optionSet.id
    );
    return pickTranslation(foundOption, i18next.language, "name");
  }
  switch (foundItem.valueType) {
    case "TEXT":
      return dataValue;
    case "BOOLEAN":
      return dataValue === "1" ? t("yes") : t("no");
    case "ORGANISATION_UNIT":
      return pickTranslation(
        orgUnits.find((ou) => ou.id === dataValue),
        i18next.language,
        "name"
      );
    default:
      return dataValue;
  }
};

function debounce(func, wait, immediate) {
  let timeout;

  return function () {
    const context = this,
      args = arguments;

    const later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };

    const callNow = immediate && !timeout;

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);

    if (callNow) func.apply(context, args);
  };
}

const filterOptionsByTrackedEntityAttribute = (teaId, metadata) => {
  const { options, trackedEntityAttributes } = metadata;
  const result = options
    .filter(
      (option) =>
        option.optionSet.id ===
        trackedEntityAttributes.find((tea) => tea.id === teaId)?.optionSet?.id
    )
    .sort((a, b) => a.sortOrder - b.sortOrder);
  return result;
};

const downloadExcel = (data, fileName = "data", sheetName = "Sheet1") => {
  // Sample array of objects

  // Convert the array of objects to a worksheet
  const worksheet = XLSX.utils.json_to_sheet(data);

  // Create a new workbook
  const workbook = XLSX.utils.book_new();

  // Append the worksheet to the workbook
  XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

  // Generate a binary string representation of the workbook
  const wbout = XLSX.write(workbook, { bookType: "xlsx", type: "binary" });

  // Function to convert a binary string to a Blob
  const s2ab = (s) => {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i < s.length; i++) {
      view[i] = s.charCodeAt(i) & 0xff;
    }
    return buf;
  };

  // Create a Blob from the binary string
  const blob = new Blob([s2ab(wbout)], { type: "application/octet-stream" });

  // Create a link element and trigger a download
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = `${fileName}.xlsx`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
const getCurrentDateFormatted = () => {
  const date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are zero-based, so add 1
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}${month}${day}`;
};

export {
  sortStringInArrayOfObject,
  pull,
  findHeaderIndex,
  getNewestDate,
  findOptionSet,
  checkValue,
  checkValueAttribute,
  getComparator,
  stableSort,
  convertMasterFacilitiesListFromSqlView,
  convertDataByDataType,
  pickTranslation,
  debounce,
  filterOptionsByTrackedEntityAttribute,
  downloadExcel,
  getCurrentDateFormatted,
};
